<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="月份：">
              <el-date-picker
                style="width:193px;"
                v-model="form.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:15px">  
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:api,data:form,callback:_d => tableData = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计月份：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('czdjsyrytjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._u"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/城镇登记失业人员统计表--导入.xls" download="城镇登记失业人员统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button type="primary" v-if="showBtn[5].isShow" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button  type="primary"
             
            v-loading.fullscreen.lock="lodaingTime" 
            @click="Filter_export(`${api}/export`,form)" 
            icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="城镇失业人员统计表"
      :visible.sync="centerDialogVisible"
      @close="close"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="登记失业人员上期结转人数：">
                          <el-input style="width:193px;" v-model="editForm.lastLostJobPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="登记失业人员本期新增人数：">
                          <el-input style="width:193px;" v-model="editForm.currentAddPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="女性：">
                          <el-input style="width:193px;" v-model="editForm.currentAddFemaleCount"></el-input>
                        </el-form-item>
                        <el-form-item label="就业转失业：">
                          <el-input style="width:193px;" v-model="editForm.currentWorkToLostJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="高校毕业生：">
                          <el-input style="width:193px;" v-model="editForm.currentUniversityCount"></el-input>
                        </el-form-item>
                        <el-form-item label="港澳台人员：">
                          <el-input style="width:193px;" v-model="editForm.currentGatCount"></el-input>
                        </el-form-item>
                        <el-form-item label="就业困难人员：">
                          <el-input style="width:193px;" v-model="editForm.currentDifficultCount"></el-input>
                        </el-form-item>
                        <el-form-item label="残疾人：">
                          <el-input style="width:193px;" v-model="editForm.currentDisableManCount"></el-input>
                        </el-form-item>
                        <el-form-item label="登记失业人员本期就业人数：">
                          <el-input style="width:193px;" v-model="editForm.currentGetjobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="女性：">
                          <el-input style="width:193px;" v-model="editForm.currentGetJobFemale"></el-input>
                        </el-form-item>
                        <el-form-item label="高校毕业生：">
                          <el-input style="width:193px;" v-model="editForm.currentGetJobUniversity"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="登记失业人员期末实有人数：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="女性：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobFemaleCount"></el-input>
                        </el-form-item>
                        <el-form-item label="高校毕业生：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobUniversity"></el-input>
                        </el-form-item>
                        <el-form-item label="港澳台人员：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobGat"></el-input>
                        </el-form-item>
                        <el-form-item label="就业困难人员：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobDifficult"></el-input>
                        </el-form-item>
                        <el-form-item label="长期失业者：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobContinue"></el-input>
                        </el-form-item>
                        <el-form-item label="残疾人：">
                          <el-input style="width:193px;" v-model="editForm.nowLostJobDiableMan"></el-input>
                        </el-form-item>
                        <el-form-item label="期末从业人员总数：">
                          <el-input style="width:193px;" v-model="editForm.nowHaveJob"></el-input>
                        </el-form-item>
                        <el-form-item label="登记失业率：">
                          <el-input style="width:193px;" v-model="editForm.lostJobPercent"></el-input>
                        </el-form-item>
                        <el-form-item label="录入时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.month"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/lostJobPerson',
      form:{},
      type:'15',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'lastLostJobPersons;',value:'登记失业人员上期结转人数'},
        {key:'currentAddPersons',value:'登记失业人员本期新增人数'},
        {key:'currentAddFemaleCount',value:'女性'},
        {key:'currentWorkToLostJobCount',value:'就业转失业'},
        {key:'currentUniversityCount',value:'高校毕业生'},
        {key:'currentGatCount',value:'港澳台人员'},
        {key:'currentDifficultCount',value:'就业困难人员'},
        {key:'currentDisableManCount',value:'残疾人'},
        {key:'currentGetjobCount',value:'登记失业人员本期就业人数'},
        {key:'currentGetJobFemale',value:'女性'},
        {key:'currentGetJobUniversity',value:'高校毕业生'},
        {key:'currentGetJobGat',value:'港澳台人员'},
        {key:'currentGetJobDifficult',value:'就业困难人员'},
        {key:'currentGetJobDisableMan',value:'残疾人'},
        {key:'nowLostJobCount',value:'登记失业人员期末实有人数'},
        {key:'nowLostJobFemaleCount',value:'女性'},
        {key:'nowLostJobUniversity',value:'高校毕业生'},
        {key:'nowLostJobGat',value:'港澳台人员'},
        {key:'nowLostJobDifficult',value:'就业困难人员'},
        {key:'nowLostJobContinue',value:'长期失业者'},
        {key:'nowLostJobDiableMan',value:'残疾人'},
        {key:'nowHaveJob',value:'期末从业人员总数'},
        {key:'lostJobPercent',value:'登记失业率'},
        {key:'month',value:'导入时间'},
      ],
      baseInfo1:[
        {key:'areaName',value:'行政区划'},
        {key:'lastLostJobPersons',value:'登记失业人员上期结转人数'},
        {key:'currentAddPersons',value:'登记失业人员本期新增人数'},
        {key:'currentAddFemaleCount',value:'女性'},
        {key:'currentWorkToLostJobCount',value:'就业转失业'},
        {key:'currentUniversityCount',value:'高校毕业生'},
        {key:'currentGatCount',value:'港澳台人员'},
        {key:'currentDifficultCount',value:'就业困难人员'},
        {key:'currentDisableManCount',value:'残疾人'},
        {key:'currentGetjobCount',value:'登记失业人员本期就业人数'},
        {key:'currentGetJobFemale',value:'女性'},
        {key:'currentGetJobUniversity',value:'高校毕业生'},
        {key:'currentGetJobGat',value:'港澳台人员'},
        {key:'currentGetJobDifficult',value:'就业困难人员'},
        {key:'currentGetJobDisableMan',value:'残疾人'},
        {key:'nowLostJobCount',value:'登记失业人员期末实有人数'},
        {key:'nowLostJobFemaleCount',value:'女性'},
        {key:'nowLostJobUniversity',value:'高校毕业生'},
        {key:'nowLostJobGat',value:'港澳台人员'},
        {key:'nowLostJobDifficult',value:'就业困难人员'},
        {key:'nowLostJobContinue',value:'长期失业者'},
        {key:'nowLostJobDiableMan',value:'残疾人'},
        {key:'nowHaveJob',value:'期末从业人员总数'},
        {key:'lostJobPercent',value:'登记失业率'},
      ],
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
      },
      isCreate:false,
      out:false
    }
  },
  created() {
    this.isShowBtn("LostJobPerson")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}


</style>